export class SuperUser {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  mobile_no: string;

  constructor(args: any) {
    this.id = args.id;
    this.firstname = args.firstname;
    this.lastname = args.lastname;
    this.email = args.email;
    this.mobile_no = args.mobile_no;
  }
}
